import styled from "styled-components";
import { Divider as AntDivider } from "antd";
import { COLORS } from "../../layout/theme";

export const Inner = styled.div`
	min-height: 90vh;
`;
export const Actions = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: start;
	gap: 20px;
`;
export const Action = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 10px;
	font-size: 14pt;
	padding: 10px;
	border-radius: 10px;
	${(props) => `cursor: ${props.cursor ? "pointer" : "auto"};`}
	${(props) => props.border && `border: 1px solid ${COLORS.LightGrey};`}
`;
export const Top = styled.div`
	display: flex;
	width: 100%;
	justify-content: space-between;
	align-items: center;
`;

export const Container = styled.div`
	display: flex;
	gap: 10px;
`;

export const Separator = styled.div`
	width: 100%;
`;

export const Divider = styled(AntDivider)`
	margin: 10px 0;
`;
